import { getCurrentInstance } from "vue";

/**
 * Get vue instance
 */
export function useRoot() {
  const root = getCurrentInstance();
  return root.proxy;
}
